const config = {
  googleAnalyticsTrackingId: "UA-90851529-1",
  mixpanelToken: "82c86744eeb53101638cc8cf48de63ec",
  apiUrl: "https://api-dr.sunbit.com",
  apiUrlPci: 'https://api-icp-dr.sunbit.com',
};

export default config;



// WEBPACK FOOTER //
// ./src/config/nvirginia-prod.js